import React from 'react';

interface EyeIconProps {
  size?: number;
  className?: string;
}

/**
 * Eye icon for showing/unhiding content
 * Used for the "show in feed" / "unhide" functionality
 */
export const EyeIcon: React.FC<EyeIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export default EyeIcon;
